// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"DJ+WbGQ+Qs8phVkA-PVkHQ==","active":"osNTJ48-2pBup6tjDjyGbQ=="};